<template>
  <div class="page-wrapper">
    <div class="container-fluid py-3 phancongxe">
      <div class="d-flex align-items-center flex-wrap mb-3" style="gap:12px;">
        <h4 class="mb-0"><i class="fa fa-user-cog mr-2"></i>Lệnh Giao Xe</h4>

        <div class="ml-auto d-flex flex-wrap" style="gap:8px;">
          <div class="input-group" style="width: 320px;">
            <input v-model.trim="qXe" type="text" class="form-control" placeholder="Tìm xe theo biển số..." @keyup.enter="refreshXe()">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" @click="refreshXe()" :disabled="loadingXe">
                 <i class="fa fa-search" v-if="!loadingXe"></i>
                 <span v-else class="spinner-border spinner-border-sm"></span>
              </button>
            </div>
          </div>
          <select class="form-control" style="width:auto" v-model.number="pageSize" @change="changeSize">
            <option :value="5">5</option>
            <option :value="10">10</option>
            <option :value="20">20</option>
          </select>
        </div>
      </div>

      <div class="row no-gutters">

        <div class="col-lg-6 pr-lg-2 mb-3 mb-lg-0">
          <div class="card h-100">
            <div class="card-header font-weight-bold">
              <i class="fa fa-car mr-2"></i> Danh sách Xe
            </div>
            <div class="card-body p-0">
              <div v-if="loadingXe" class="p-4 text-center">
                <div class="spinner-border text-primary"></div>
                <div class="mt-2 text-muted">Đang tải danh sách xe…</div>
              </div>
              <div v-else-if="!xeItems.length" class="p-4 text-center text-muted">
                Không tìm thấy xe nào{{ qXe ? ' khớp với "' + qXe + '"' : '' }}.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 72px;">Ảnh</th>
                      <th>Biển số / Hãng</th>
                      <th>Phân công hiện tại</th>
                      <th class="text-right">Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="x in xeItems" :key="x.id" :class="{ 'table-active': x.id === selectedXeId }" @click="selectXe(x)" style="cursor: pointer;">
                      <td>
                        <img :src="x.fileUrl || '/assets/img/placeholder-car.png'"
                             alt="Ảnh xe"
                             style="width:56px;height:40px;object-fit:cover;border-radius:4px;border:1px solid #eee;">
                      </td>
                      <td class="align-middle">
                        <div class="font-weight-bold">{{ x.bienSo }}</div>
                        <small class="text-muted">{{ x.hangXe || '-' }} {{ x.model || '' }}</small>
                      </td>
                      <td class="align-middle">
                        <span v-if="currentAssignMap[x.id]"
                              class="badge"
                              :class="{
                                'badge-secondary': currentAssignMap[x.id].trangThai === 'ASSIGNED',
                                'badge-success': currentAssignMap[x.id].trangThai === 'IN_USE',
                                'badge-light': currentAssignMap[x.id].trangThai === 'CLOSED' // Nên được ẩn đi nếu CLOSED
                              }"
                              :title="'Loại: ' + currentAssignMap[x.id].loai + ' | Từ: ' + fmt(currentAssignMap[x.id].startAt)">
                          <i class="fa fa-user mr-1"></i> {{ currentAssignMap[x.id].tenTaiXe || 'N/A' }}
                        </span>
                         <span v-else-if="!currentAssignMap[x.id] || currentAssignMap[x.id]?.trangThai === 'CLOSED'" class="text-muted small">
                            <i class="fa fa-check-circle text-success mr-1"></i> Sẵn sàng
                        </span>
                         <span v-else class="spinner-border spinner-border-sm text-secondary" title="Đang tải trạng thái..."></span>
                      </td>
                      <td class="text-right align-middle">
                        <div class="btn-group btn-group-sm">
                          <button class="btn btn-outline-success" title="Tạo Lệnh Giao Xe Mới" @click.stop="openAssign(x)">
                            <i class="fa fa-user-plus"></i>
                          </button>
                          <button class="btn btn-outline-warning" title="Bàn Giao/Điều Động Xe Này" @click.stop="openHandover(x)" :disabled="!currentAssignMap[x.id] || currentAssignMap[x.id].trangThai === 'CLOSED'">
                            <i class="fa fa-exchange"></i>
                          </button>
                           <button class="btn btn-outline-danger" title="Kết Thúc Lệnh Giao Xe Hiện Tại" @click.stop="openTerminate(currentAssignMap[x.id])" :disabled="!currentAssignMap[x.id] || currentAssignMap[x.id].trangThai === 'CLOSED'">
                            <i class="fa fa-user-times"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="totalPages > 1" class="p-2 border-top d-flex align-items-center justify-content-between">
                <small class="text-muted">Tổng: {{ totalElements }} xe — Trang {{ page }}/{{ totalPages }}</small>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: page === 1 }">
                    <a href="#" class="page-link" @click.prevent="goPage(page - 1)">Trước</a>
                  </li>
                  <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: page === p }">
                    <a href="#" class="page-link" @click.prevent="goPage(p)">{{ p }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: page === totalPages }">
                    <a href="#" class="page-link" @click.prevent="goPage(page + 1)">Sau</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 pl-lg-2">
          <div class="card h-100">
            <div class="card-header d-flex align-items-center justify-content-between">
              <div class="font-weight-bold"><i class="fa fa-clipboard-list mr-2"></i>Chi tiết phân công</div>
              <div v-if="selectedXe" class="small text-muted">Xe: <strong>{{ selectedXe.bienSo }}</strong></div>
            </div>
            <div class="card-body d-flex flex-column">
              <div v-if="!selectedXe" class="text-muted text-center py-5 my-auto">
                <i class="fa fa-arrow-left fa-2x mb-2"></i>
                <p>Chọn một xe ở bảng bên trái<br>để xem chi tiết.</p>
              </div>

              <template v-else>
                <div class="mb-3">
                  <h6 class="font-weight-bold mb-2"><i class="fa fa-user-tag mr-2 text-primary"></i>Lệnh giao xe hiện tại</h6>
                  <div v-if="loadingAssign && !currentAssign && selectedXeId" class="text-center text-muted py-3">
                    <span class="spinner-border spinner-border-sm text-primary"></span> Đang tải…
                  </div>
                  <div v-else-if="!currentAssign" class="alert alert-success py-2">
                     <i class="fa fa-check-circle mr-1"></i> Xe đang <strong class="text-uppercase">Sẵn Sàng</strong>.
                     <button class="btn btn-sm btn-primary float-right" @click="openAssign(selectedXe)">
                         <i class="fa fa-user-plus mr-1"></i> Giao xe này
                     </button>
                  </div>
                  <div v-else class="border rounded p-3 bg-light position-relative">
                    <div class="d-flex align-items-center" style="gap:12px;">
                       <div class="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-sm"
                           style="width:48px;height:48px;border:1px solid #eee;">
                         <i class="fa fa-user fa-lg text-secondary"></i>
                       </div>
                       <div>
                         <div class="font-weight-bold">{{ currentAssign.tenTaiXe }}</div>
                         <div class="small text-muted">
                           Trạng thái:
                           <span class="badge"
                                :class="{
                                  'badge-secondary': currentAssign.trangThai==='ASSIGNED',
                                  'badge-success': currentAssign.trangThai==='IN_USE',
                                }">{{ currentAssign.trangThai === 'ASSIGNED' ? 'Đã Giao' : 'Đang Sử Dụng' }}</span>
                           · Loại: <span class="badge badge-info">{{ currentAssign.loai === 'FIXED' ? 'Lâu dài' : 'Tạm thời' }}</span>
                         </div>
                         <div class="small text-muted">
                           Từ: {{ fmt(currentAssign.startAt) }}
                           <span v-if="currentAssign.endAt"> — Đến: {{ fmt(currentAssign.endAt) }}</span>
                         </div>
                         <div v-if="currentAssign.lyDo" class="small text-muted" title="Lý do">
                            <i class="fa fa-info-circle mr-1"></i> {{ currentAssign.lyDo }}
                         </div>
                       </div>
                    </div>
                     <button class="btn btn-sm btn-outline-danger position-absolute"
                             style="top: 10px; right: 10px;"
                             title="Kết thúc lệnh giao xe này"
                             @click="openTerminate(currentAssign)">
                       <i class="fa fa-user-times"></i> Kết thúc lệnh
                     </button>
                  </div>
                </div>

                <div class="mb-4 d-flex flex-wrap" style="gap:8px;">
                   <button class="btn btn-sm btn-primary" @click="openAssign(selectedXe)">
                     <i class="fa fa-user-plus mr-1"></i> Tạo Lệnh Giao Mới
                   </button>
                   <button class="btn btn-sm btn-warning" @click="openHandover(selectedXe)" :disabled="!currentAssign || currentAssign.trangThai === 'CLOSED'">
                     <i class="fa fa-exchange-alt mr-1"></i> Bàn Giao/Điều Động
                   </button>
                </div>

                <div class="flex-grow-1 d-flex flex-column">
                  <h6 class="font-weight-bold mb-2"><i class="fa fa-history mr-2 text-secondary"></i>Lịch sử phân công</h6>
                   <div v-if="loadingAssign && !history.length" class="text-center text-muted py-3">
                    <span class="spinner-border spinner-border-sm text-secondary"></span> Đang tải lịch sử…
                   </div>
                  <div v-else-if="!history.length" class="text-muted small text-center py-3">Chưa có lịch sử.</div>
                  <div v-else class="table-responsive flex-grow-1" style="max-height: 400px; overflow-y: auto;">
                    <table class="table table-sm table-bordered">
                      <thead class="thead-light" style="position: sticky; top: 0; z-index: 1;">
                        <tr>
                          <th>Tài xế</th>
                          <th>Loại</th>
                          <th>Trạng thái</th>
                          <th>Bắt đầu</th>
                          <th>Kết thúc</th>
                          <th>Lý do</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pc in history" :key="pc.id">
                          <td>{{ pc.tenTaiXe }}</td>
                          <td><span class="badge badge-info">{{ pc.loai === 'FIXED' ? 'Lâu dài' : 'Tạm thời' }}</span></td>
                          <td>
                            <span class="badge"
                               :class="{
                                 'badge-secondary': pc.trangThai==='ASSIGNED',
                                 'badge-success': pc.trangThai==='IN_USE',
                                 'badge-light': pc.trangThai==='CLOSED'
                               }">{{ pc.trangThai === 'ASSIGNED' ? 'Đã Giao' : (pc.trangThai === 'IN_USE' ? 'Sử Dụng' : 'Đã Đóng') }}</span>
                          </td>
                          <td class="small">{{ fmt(pc.startAt, 'compact') }}</td>
                          <td class="small">{{ pc.endAt ? fmt(pc.endAt, 'compact') : '-' }}</td>
                          <td class="small">{{ pc.lyDo || '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template> </div> </div> </div> </div> <div v-if="assignOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog">
          <div class="modal-content">
            <form @submit.prevent="doAssign">
              <div class="modal-header">
                <h5 class="modal-title"><i class="fa fa-user-plus mr-2 text-success"></i>Lệnh Giao Xe: {{ selectedXe?.bienSo }}</h5>
                <button type="button" class="close" @click="closeAssignModal"><span>&times;</span></button>
              </div>
              <div class="modal-body">
                <div v-if="assignFormError" class="alert alert-danger py-2">{{ assignFormError }}</div>

                <label class="font-weight-bold">Chọn tài xế <span class="text-danger">*</span></label>
                <div class="input-group mb-2">
                  <input class="form-control" v-model.trim="userQuery" placeholder="Tìm tài xế theo tên..." @input="filterUserOptionsDebounced" @keyup.enter.prevent="filterUserOptions">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="filterUserOptions" :disabled="taiXeListLoading">
                      <i class="fa fa-filter" v-if="!taiXeListLoading"></i>
                      <span v-else class="spinner-border spinner-border-sm"></span>
                    </button>
                  </div>
                </div>
                <div v-if="taiXeListLoading" class="text-center text-muted mb-2">
                    <span class="spinner-border spinner-border-sm"></span> Đang tải danh sách tài xế...
                </div>
                <select class="form-control mb-3" v-model="assignForm.taiXeId" size="6" required :disabled="taiXeListLoading">
                  <option :value="null" disabled>-- Chọn tài xế từ danh sách --</option>
                  <option v-for="u in userOptions" :key="u.idNguoiDung" :value="u.idNguoiDung">
                    {{ u.hoTen }} <span v-if="u.tenDangNhap">({{ u.tenDangNhap }})</span>
                  </option>
                  <option v-if="!taiXeListLoading && userOptions.length === 0" disabled>
                    {{ userQuery ? 'Không tìm thấy tài xế khớp' : (allTaiXeOptions.length > 0 ? 'Không có tài xế nào' : 'Lỗi tải danh sách') }}
                  </option>
                </select>

                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label>Loại lệnh <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="assignForm.loai" required>
                      <option value="FIXED">Giao Lâu dài</option>
                      <option value="TEMP">Giao Tạm thời</option>
                    </select>
                  </div>
                   <div class="form-group col-md-7">
                    <label>Lý do</label>
                    <input class="form-control" v-model.trim="assignForm.lyDo" placeholder="(Tùy chọn)">
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Bắt đầu từ</label>
                    <input type="datetime-local" class="form-control" v-model="assignForm.startAt">
                    <small class="text-muted">Để trống = Ngay bây giờ</small>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Kết thúc vào (Nếu là TEMP)</label>
                    <input type="datetime-local" class="form-control" v-model="assignForm.endAt" :disabled="assignForm.loai !== 'TEMP'">
                     <small class="text-muted">Để trống = Không giới hạn</small>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-secondary" type="button" @click="closeAssignModal">Huỷ</button>
                <button class="btn btn-success" type="submit" :disabled="loading"> <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fa fa-check mr-1"></i> Xác nhận Giao xe
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-if="handoverOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog">
          <div class="modal-content">
            <form @submit.prevent="doHandover">
              <div class="modal-header">
                <h5 class="modal-title"><i class="fa fa-exchange-alt mr-2 text-warning"></i>Bàn Giao Xe: {{ selectedXe?.bienSo }}</h5>
                <button type="button" class="close" @click="closeHandoverModal"><span>&times;</span></button>
              </div>
              <div class="modal-body">
                 <div v-if="assignFormError" class="alert alert-danger py-2">{{ assignFormError }}</div>

                <div v-if="currentAssign" class="alert alert-info py-2 small">
                  Xe đang được giao cho: <strong>{{ currentAssign.tenTaiXe }}</strong>. Lệnh này sẽ kết thúc lệnh giao hiện tại.
                </div>

                <label class="font-weight-bold">Chọn tài xế MỚI nhận xe <span class="text-danger">*</span></label>
                <div class="input-group mb-2">
                   <input class="form-control" v-model.trim="userQuery" placeholder="Tìm tài xế theo tên..." @input="filterUserOptionsDebounced" @keyup.enter.prevent="filterUserOptions">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="filterUserOptions" :disabled="taiXeListLoading">
                      <i class="fa fa-filter" v-if="!taiXeListLoading"></i>
                      <span v-else class="spinner-border spinner-border-sm"></span>
                    </button>
                  </div>
                </div>
                 <div v-if="taiXeListLoading" class="text-center text-muted mb-2">
                    <span class="spinner-border spinner-border-sm"></span> Đang tải danh sách tài xế...
                </div>
                <select class="form-control mb-3" v-model="handoverForm.toTaiXeId" size="6" required :disabled="taiXeListLoading">
                   <option :value="null" disabled>-- Chọn tài xế mới --</option>
                   <option v-for="u in userOptions" :key="u.idNguoiDung" :value="u.idNguoiDung" :disabled="currentAssign && u.idNguoiDung === currentAssign.taiXeId">
                    {{ u.hoTen }} <span v-if="u.tenDangNhap">({{ u.tenDangNhap }})</span>
                     <span v-if="currentAssign && u.idNguoiDung === currentAssign.taiXeId"> (Đang giữ xe)</span>
                  </option>
                  <option v-if="!taiXeListLoading && userOptions.length === 0" disabled>
                     {{ userQuery ? 'Không tìm thấy tài xế khớp' : (allTaiXeOptions.length > 0 ? 'Không có tài xế nào' : 'Lỗi tải danh sách') }}
                  </option>
                </select>

                <div class="form-group">
                  <label>Lý do bàn giao</label>
                  <input class="form-control" v-model.trim="handoverForm.lyDo" placeholder="(Tùy chọn, ví dụ: Tài xế A nghỉ ốm)">
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-secondary" type="button" @click="closeHandoverModal">Huỷ</button>
                <button class="btn btn-warning" type="submit" :disabled="loading"> <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fa fa-check mr-1"></i> Xác nhận Bàn giao
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-if="terminateOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog">
          <div class="modal-content">
            <form @submit.prevent="doTerminate">
              <div class="modal-header">
                <h5 class="modal-title"><i class="fa fa-user-times mr-2 text-danger"></i>Kết thúc Lệnh Giao Xe</h5>
                <button type="button" class="close" @click="closeTerminateModal"><span>&times;</span></button>
              </div>
              <div class="modal-body">
                <div v-if="assignFormError" class="alert alert-danger py-2">{{ assignFormError }}</div>

                <p v-if="pendingTerminate">Bạn có chắc chắn muốn kết thúc lệnh giao xe <strong>{{ selectedXe?.bienSo }}</strong> hiện tại cho tài xế <strong>{{ pendingTerminate.tenTaiXe }}</strong>?</p>
                <p class="small text-muted">Hành động này sẽ chuyển trạng thái lệnh giao thành "CLOSED" và xe sẽ trở nên Sẵn Sàng (nếu không có lệnh nào khác).</p>

                <div class="form-group">
                  <label>Lý do kết thúc (Tùy chọn)</label>
                  <input class="form-control" v-model.trim="terminateForm.lyDo" placeholder="Ví dụ: Tài xế nghỉ việc, Thu hồi xe...">
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-secondary" type="button" @click="closeTerminateModal">Huỷ</button>
                <button class="btn btn-danger" type="submit" :disabled="loading"> <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fa fa-check mr-1"></i> Xác nhận Kết thúc
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

       </div> </div> </template>

<script>
import { mapState, mapActions } from 'pinia';
import { useXePhanCongStore } from '@/stores/xePhanCongStore';
import { XeApi } from '@/services/xeService';
import { XePhanCongApi } from '@/services/xePhanCongService';
// Giả sử service người dùng cũng export named
// import { NguoiDungApi } from '@/services/nguoiDungService';

// Helper format ngày giờ
function pad2(n) { return String(n).padStart(2, '0'); }
function parseIsoLocal(s) {
    if (!s) return null;
    if (s instanceof Date) return s;
    const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
    if (!m) return null;
    const [, y, M, d, h, mi, se] = m;
    // Tạo Date object theo giờ địa phương
    return new Date(+y, +M - 1, +d, +h, +mi, +se);
}
function fmt(s, style = 'compact') {
    const d = parseIsoLocal(s);
    if (!d) return '-';
    const dd = pad2(d.getDate());
    const MM = pad2(d.getMonth() + 1);
    const yyyy = d.getFullYear();
    const hh = pad2(d.getHours());
    const mm = pad2(d.getMinutes());
    // Bỏ giây cho gọn
    if (style === 'long') {
        return `${hh}:${mm} ngày ${dd} tháng ${MM} năm ${yyyy}`;
    }
    return `${dd}/${MM}/${yyyy} ${hh}:${mm}`;
}

// Debounce helper
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}


export default {
  name: 'PhanCongXe',
  data() {
    return {
      // --- State cho danh sách Xe (Component tự quản lý) ---
      qXe: '',           // Từ khóa tìm kiếm xe
      page: 1,           // Trang hiện tại (1-based)
      pageSize: 10,      // Số lượng xe mỗi trang
      totalPages: 1,     // Tổng số trang xe
      totalElements: 0,  // Tổng số xe
      loadingXe: false,  // Trạng thái tải ds xe
      xeItems: [],       // Danh sách xe hiển thị
      currentAssignMap: {}, // Map { xeId: currentAssignment } để hiển thị nhanh

      // --- State cho xe đang được chọn ---
      selectedXeId: null,
      selectedXe: null, // Lưu trữ thông tin xe đang chọn

      // --- State cho Modals ---
      assignOpen: false,    // Modal Tạo/Sửa Lệnh Giao Xe
      handoverOpen: false,  // Modal Bàn Giao Khẩn Cấp
      terminateOpen: false, // Modal xác nhận Kết thúc Phân Công (Mới)
      pendingTerminate: null, // Lưu trữ thông tin phân công sắp kết thúc

      // --- State cho Forms ---
      // assignLoading dùng chung state loading của store
      assignForm: { xeId: null, taiXeId: null, loai: 'FIXED', lyDo: '', startAt: '', endAt: '' },
      handoverForm: { xeId: null, toTaiXeId: null, lyDo: '' },
      terminateForm: { lyDo: '' }, // Form kết thúc lệnh
      assignFormError: null, // Lỗi riêng cho các modal form

      // --- State cho tìm kiếm Người dùng (Tài xế) ---
      userQuery: '',       // Input tìm kiếm của người dùng
      userOptions: [],     // Danh sách TÀI XẾ ĐÃ LỌC để hiển thị
      allTaiXeOptions: [], // Danh sách TẤT CẢ tài xế thuộc phòng ban 'TaiXe' (đã chuẩn hóa)
      taiXeListFetched: false, // Flag đánh dấu đã fetch list tài xế lần nào chưa
      taiXeListLoading: false, // State loading riêng cho việc fetch list tài xế
    };
  },
  computed: {
    // Map state từ store xePhanCongStore
    ...mapState(useXePhanCongStore, [
        'loading', // Trạng thái loading chung của store (dùng cho submit form)
        'error',   // Lỗi chung của store
        'currentByXe', // Map { xeId: PcxDto|null }
        'historyByXe', // Map { xeId: PcxDto[] }
        // 'onlyDrivers' // Bỏ đi nếu mặc định luôn là tài xế
    ]),

    // Computed property để lấy phân công hiện tại của xe đang chọn
    currentAssign() {
      if (!this.selectedXeId) return null;
      // Lấy từ map state `currentByXe` của store
      return this.currentByXe[this.selectedXeId] || null;
    },

    // Computed property để lấy lịch sử của xe đang chọn
    history() {
      if (!this.selectedXeId) return [];
      // Lấy từ map state `historyByXe` của store
      // Sắp xếp lại theo batDau giảm dần nếu cần (vì store có thể không sắp xếp)
      const historyList = this.historyByXe[this.selectedXeId] || [];
      return historyList.slice().sort((a, b) => {
          // So sánh string ISO date hoặc Date object nếu parseIsoLocal trả về Date
         const dateA = parseIsoLocal(a.startAt);
         const dateB = parseIsoLocal(b.startAt);
         if (!dateA && !dateB) return 0;
         if (!dateA) return 1; // nulls last
         if (!dateB) return -1; // nulls last
         return dateB - dateA; // Mới nhất lên trước
      });
    },

    // Có thể dùng computed assignLoading để disable nút submit
    assignLoading() {
        return this.loading; // Dùng loading chung của store
    }
  },
  methods: {
    // Map actions từ store xePhanCongStore
    ...mapActions(useXePhanCongStore, [
        'fetchCurrentByXe', // Tải phân công hiện tại theo xeId
        'fetchHistoryByXe', // Tải lịch sử phân công theo xeId
        'createAssignment', // Tạo phân công mới
        'handover',         // Bàn giao khẩn cấp
        'closeAssignment',  // Kết thúc phân công (Mới)
    ]),

    // --- Helpers ---
    fmt, // Sử dụng hàm fmt đã định nghĩa ở trên

    // --- Logic Xử lý Danh sách Xe ---
    async refreshXe() {
        this.page = 1; // Reset về trang 1 khi tìm kiếm
        await this.fetchXe();
    },
    async goPage(p) {
      if (p < 1 || p > this.totalPages || p === this.page) return;
      this.page = p;
      await this.fetchXe();
    },
     async changeSize() {
        this.page = 1; // Reset về trang 1 khi đổi size
        await this.fetchXe();
    },
    async fetchXe() {
      this.loadingXe = true;
      try {
        const params = { q: this.qXe || null, page: this.page - 1, size: this.pageSize, sort: 'id,desc' };
        // Giả định XeApi.list trả về cấu trúc { content: [], totalPages: N, totalElements: M, number: P }
        const data = await XeApi.list(params);

        this.xeItems = data?.content || [];
        this.totalElements = data?.totalElements || 0;
        this.totalPages = data?.totalPages || 1;
        // API trả về page 0-based, component dùng 1-based
        this.page = (data?.number || 0) + 1;

        // Tải nhanh phân công hiện tại cho từng xe hiển thị
        // Dùng map cục bộ để hiển thị ngay lập tức trên bảng
        this.currentAssignMap = {};
        if (this.xeItems.length > 0) {
            const promises = this.xeItems.map(x =>
              XePhanCongApi.getCurrentByXe(x.id) // Gọi service API trực tiếp
                // API getCurrentByXe trả về DTO hoặc 404 (data sẽ là null/undefined)
                .then((result) => { this.currentAssignMap[x.id] = result || null; })
                .catch(() => { this.currentAssignMap[x.id] = null; }) // Lỗi thì coi như chưa phân công
            );
            await Promise.all(promises);
        }

        // Nếu xe đang chọn không còn trong trang -> Xóa lựa chọn
        if (this.selectedXeId && !this.xeItems.some(x => x.id === this.selectedXeId)) {
          this.clearSelection();
        }
      } catch (e) {
          console.error("Lỗi tải danh sách xe:", e);
          alert("Không thể tải danh sách xe. Vui lòng thử lại."); // Thông báo lỗi
      } finally {
        this.loadingXe = false;
      }
    },

    // --- Logic Chọn Xe và Tải Dữ liệu Phân Công từ Store ---
    selectXe(x) {
      if (this.selectedXeId === x.id) return; // Không cần load lại nếu đã chọn
      this.selectedXeId = x.id;
      this.selectedXe = x;
      // Gọi actions của store để tải/lấy dữ liệu chi tiết cho xe được chọn
      this.fetchCurrentByXe(x.id);
      this.fetchHistoryByXe(x.id);
    },
    clearSelection() {
      this.selectedXeId = null;
      this.selectedXe = null;
      // Không cần reset currentAssign và history vì nó lấy từ computed
    },

    // --- Logic Mở Modals ---
    async openAssign(x) { // Thêm async
      if (!x) return;
      // Kiểm tra xem xe có đang được phân công active không (dùng map cục bộ)
      // Lấy giá trị mới nhất từ store nếu có thể, fallback về map cục bộ
      const current = this.currentByXe[x.id] !== undefined ? this.currentByXe[x.id] : this.currentAssignMap[x.id];

      if (current && current.trangThai !== 'CLOSED') {
          alert(`Xe ${x.bienSo} đang được ${current.tenTaiXe} sử dụng/phân công. Vui lòng kết thúc lệnh cũ hoặc dùng chức năng Bàn Giao.`);
          return;
      }

      this.selectXe(x); // Chọn xe luôn nếu chưa chọn
      // Reset form
      this.assignForm = { xeId: x.id, taiXeId: null, loai: 'FIXED', lyDo: '', startAt: '', endAt: '' };
      this.userQuery = ''; // Reset query tìm tài xế
      this.assignFormError = null;
      this.assignOpen = true;
      document.body.style.overflow = 'hidden';
      // Fetch danh sách tài xế KHI MỞ MODAL
      await this.fetchTaiXeListIfNeeded();
      this.filterUserOptions(); // Hiển thị list ban đầu (không lọc)
    },
    async openHandover(x) { // Thêm async
        if (!x) return;
        // Lấy giá trị mới nhất từ store nếu có thể, fallback về map cục bộ
        const current = this.currentByXe[x.id] !== undefined ? this.currentByXe[x.id] : this.currentAssignMap[x.id];

        if (!current || current.trangThai === 'CLOSED') {
            alert("Xe này hiện chưa được phân công hoặc lệnh giao đã kết thúc.");
            return;
        }

        this.selectXe(x);
        this.handoverForm = { xeId: x.id, toTaiXeId: null, lyDo: '' };
        this.userQuery = '';
        this.assignFormError = null;
        this.handoverOpen = true;
        document.body.style.overflow = 'hidden';
        await this.fetchTaiXeListIfNeeded();
        this.filterUserOptions();
    },
    openTerminate(assignment) {
        if (!assignment || assignment.trangThai === 'CLOSED') {
             alert("Lệnh giao xe này đã kết thúc hoặc không tồn tại.");
             return;
        }
        this.pendingTerminate = { ...assignment }; // Lưu bản copy
        this.terminateForm = { lyDo: '' };
        this.assignFormError = null;
        this.terminateOpen = true;
        document.body.style.overflow = 'hidden';
    },

    // --- Logic Đóng Modals ---
    closeAssignModal() { this.assignOpen = false; document.body.style.overflow = ''; },
    closeHandoverModal() { this.handoverOpen = false; document.body.style.overflow = ''; },
    closeTerminateModal() { this.terminateOpen = false; this.pendingTerminate = null; document.body.style.overflow = ''; },

    // --- Logic Tìm kiếm Tài xế (Logic Mới) ---
    // 1. Fetch danh sách TẤT CẢ tài xế thuộc phòng ban 'TaiXe' (chỉ gọi 1 lần)
    async fetchTaiXeListIfNeeded() {
        if (this.taiXeListFetched) return; // Đã fetch rồi

        this.taiXeListLoading = true;
        this.assignFormError = null; // Reset lỗi cũ
        try {
            // Gọi API lấy user theo Mã Phòng Ban 'TaiXe'
            // Giả định API trả về List<NguoiDungResponse>
          const data = await XePhanCongApi.usersByPhongBanCode('TaiXe'); // Dùng service
            console.log("check tài xế: ", data)
          const list = Array.isArray(data.data) ? data.data : [];
            console.log("check: ", list)

            // Chuẩn hóa dữ liệu 1 lần và lưu vào allTaiXeOptions
            // Sắp xếp theo tên để dễ chọn
            this.allTaiXeOptions = list.map(u => ({
                idNguoiDung: u.idNguoiDung,
                hoTen: (u.hoTen || '').trim(),
                tenDangNhap: (u.tenDangNhap || '').trim(),
            }))
            .filter(u => !!u.idNguoiDung) // Lọc bỏ user không có ID
            .sort((a, b) => a.hoTen.localeCompare(b.hoTen, 'vi')); // Sắp xếp theo tên tiếng Việt

            this.taiXeListFetched = true; // Đánh dấu đã fetch thành công

        } catch (e) {
            console.error("Lỗi tải danh sách tài xế:", e);
            this.allTaiXeOptions = []; // Reset nếu lỗi
            this.assignFormError = "Không tải được danh sách tài xế.";
            this.taiXeListFetched = false; // Cho phép thử lại lần sau
        } finally {
            this.taiXeListLoading = false; // Tắt loading riêng
        }
    },
    // 2. Filter danh sách tài xế đã fetch dựa trên userQuery (Client-side)
    filterUserOptions() {
        const q = (this.userQuery || '').toLowerCase().trim();
        if (!q) {
            // Nếu query rỗng, hiển thị toàn bộ list đã fetch
            this.userOptions = this.allTaiXeOptions;
        } else {
            // Nếu có query, lọc từ list đã fetch
            this.userOptions = this.allTaiXeOptions.filter(u =>
                u.hoTen.toLowerCase().includes(q) ||
                u.tenDangNhap.toLowerCase().includes(q)
            );
        }
    },
    // 3. Debounce cho việc filter khi người dùng gõ
    filterUserOptionsDebounced: debounce(function() { this.filterUserOptions(); }, 300), // Giảm debounce time

    // --- Logic Submit Forms (Gọi actions của store) ---
    async doAssign() {
      this.assignFormError = null;
      if (!this.assignForm.xeId || !this.assignForm.taiXeId) { this.assignFormError = 'Vui lòng chọn xe và tài xế.'; return; }
      if (this.assignForm.startAt && this.assignForm.endAt && this.assignForm.endAt < this.assignForm.startAt) { this.assignFormError = 'Thời gian kết thúc không được trước thời gian bắt đầu.'; return; }

      try {
        // Format datetime-local sang ISO YYYY-MM-DDTHH:MM:SS (cho backend Java)
        const formatDateTimeLocal = (dtString) => {
            if (!dtString) return null;
            try {
                // Input type="datetime-local" trả về "YYYY-MM-DDTHH:MM"
                // Chỉ cần thêm giây ":00" là thành ISO 8601 local
                return dtString + ':00';
            } catch { return null; }
        };

        const payload = {
          xeId: this.assignForm.xeId,
          taiXeId: this.assignForm.taiXeId,
          loai: this.assignForm.loai,
          lyDo: this.assignForm.lyDo?.trim() || null,
          startAt: formatDateTimeLocal(this.assignForm.startAt),
          endAt: formatDateTimeLocal(this.assignForm.endAt),
        };

        await this.createAssignment(payload); // Gọi action store
        this.closeAssignModal();

        // Cập nhật map hiển thị (lấy từ store sau khi fetch lại)
        // Dùng $nextTick để đợi store cập nhật xong (hoặc không cần nếu computed tự update)
        this.$nextTick(() => {
             const updatedAssign = this.currentByXe[payload.xeId];
             // Cần tạo bản copy để tránh Vue warning khi mutate prop
             this.currentAssignMap[payload.xeId] = updatedAssign ? { ...updatedAssign } : null;
             // Trigger re-render nếu cần
             this.$forceUpdate(); // Hoặc cách khác để update Map
        });
        alert('Giao xe thành công!');

      } catch (e) {
        this.assignFormError = e?.response?.data?.message || e?.message || 'Giao xe thất bại.';
        console.error("Lỗi giao xe:", e);
      }
      // loading state được quản lý bởi store
    },
    async doHandover() {
       this.assignFormError = null;
       if (!this.handoverForm.xeId || !this.handoverForm.toTaiXeId) { this.assignFormError = 'Vui lòng chọn xe và tài xế mới.'; return; }
       const currentAssignForHandover = this.currentByXe[this.handoverForm.xeId];
       if (currentAssignForHandover && currentAssignForHandover.taiXeId === this.handoverForm.toTaiXeId) { this.assignFormError = 'Không thể bàn giao cho chính tài xế đang giữ xe.'; return; }

      try {
        await this.handover( // Gọi action store
          this.handoverForm.xeId,
          this.handoverForm.toTaiXeId,
          this.handoverForm.lyDo?.trim() || null
        );
        this.closeHandoverModal();
        // Cập nhật map hiển thị
         this.$nextTick(() => {
             const updatedAssign = this.currentByXe[this.handoverForm.xeId];
             this.currentAssignMap[this.handoverForm.xeId] = updatedAssign ? { ...updatedAssign } : null;
             this.$forceUpdate();
        });
         alert('Bàn giao xe thành công!');
      } catch (e) {
        this.assignFormError = e?.response?.data?.message || e?.message || 'Bàn giao thất bại.';
         console.error("Lỗi bàn giao xe:", e);
      }
    },
    async doTerminate() {
        if (!this.pendingTerminate) return;
        this.assignFormError = null;
        const assignmentIdToClose = this.pendingTerminate.id;
        const xeIdToRefresh = this.pendingTerminate.xeId;

        try {
            // Gọi action mới của store
            await this.closeAssignment(
                assignmentIdToClose,
                xeIdToRefresh, // Truyền xeId để store biết refresh
                this.terminateForm.lyDo?.trim() || null
            );
            this.closeTerminateModal();
            // Cập nhật map hiển thị
             this.$nextTick(() => {
                 // Sau khi kết thúc, currentByXe[xeId] sẽ là null
                 this.currentAssignMap[xeIdToRefresh] = null;
                 this.$forceUpdate();
             });
             alert('Kết thúc lệnh giao xe thành công!');
        } catch (e) {
            this.assignFormError = e?.response?.data?.message || e?.message || 'Kết thúc lệnh giao xe thất bại.';
            console.error("Lỗi kết thúc giao xe:", e);
        }
    },

  },

  mounted() {
    this.fetchXe(); 
  },
};
</script>